export default "__VITE_ASSET__QSFLqlv$__"